import { useEffect } from "@wordpress/element";
import React from "react";
import { useStyleRenderer } from "../../../../wp-utils/v1/hooks";

const Styles = ({ attributes, setAttributes }) => {
  const { uniqueId, presetData = {} } = attributes;
  const { position, color, backgroundColor, opacity } = presetData?.preset?.watermark || {};
  const { CSS } = useStyleRenderer({ ...presetData?.preset, ...attributes }, `#${uniqueId}`);

  useEffect(() => {
    const watermarkCSS = `#${uniqueId} .watermark  {
        justify-content: ${position};
      }
      #${uniqueId} .watermark span {
        background-color: ${backgroundColor};
        color: ${color};
        opacity: ${opacity}
      }`
      .replaceAll("  ", "")
      .replaceAll("\n", "");

    setAttributes({ CSS: `${CSS}${watermarkCSS}` });
  }, [CSS, presetData]);

  return <style dangerouslySetInnerHTML={{ __html: CSS }}></style>;
};

export default Styles;
